import { render, staticRenderFns } from "./Unauthorized401.vue?vue&type=template&id=8dbb3550&"
import script from "./Unauthorized401.vue?vue&type=script&lang=js&"
export * from "./Unauthorized401.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports